import api from '@/client/core/api'
import {
  GetInstagramInstantwinPrizeByIdResponse,
  InstantwinPrizeDetail
} from '@/typings/api/instagram_instantwin_prizes.schema'

/**
 * Instagram インスタントウィン応募グループをIDで取得
 *
 * @param prizeId - 応募グループID
 * @returns 応募グループ詳細
 * @throws データ取得に失敗した場合にエラーをthrow
 *
 * @example
 * const prize = await getInstagramInstantwinPrize(1)
 */
export async function getInstagramInstantwinPrize(prizeId: number): Promise<InstantwinPrizeDetail> {
  const result = await api.get<GetInstagramInstantwinPrizeByIdResponse>(`/instagram_instantwin_prizes/${prizeId}`)

  return result.data
}
